export default __webpack_public_path__ + "static/media/LightBlue0005.3a42f005.png";